var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-banner"},[_c('div',{staticClass:"container"},[_c('div',{directives:[{name:"imagekit",rawName:"v-imagekit.background",value:({
        image: _vm.event.picture,
        transform: 'h-400,fo-auto'
      }),expression:"{\n        image: event.picture,\n        transform: 'h-400,fo-auto'\n      }",modifiers:{"background":true}}],staticClass:"image-wrapper"})])])}
var staticRenderFns = []

export { render, staticRenderFns }